import { compose } from 'recompose';
import UserGroup from './UserGroup';
import apiInterceptor from '../../../api/interceptor';
import { userGroupApi } from '../../common/base.api';

const composedUserGroup = compose(apiInterceptor({ ...userGroupApi }))(UserGroup);

export default composedUserGroup;
